export var RuleComponent;
(function (RuleComponent) {
    RuleComponent["RULE_COMPONENT_UNSPECIFIED"] = "RULE_COMPONENT_UNSPECIFIED";
    RuleComponent["RULE_COMPONENT_NUMBER_OF_COPIES"] = "RULE_COMPONENT_NUMBER_OF_COPIES";
    RuleComponent["RULE_COMPONENT_MINIMUM_RETENTION"] = "RULE_COMPONENT_MINIMUM_RETENTION";
    RuleComponent["RULE_COMPONENT_MAXIMUM_RETENTION"] = "RULE_COMPONENT_MAXIMUM_RETENTION";
    RuleComponent["RULE_COMPONENT_CROSS_ACCOUNT"] = "RULE_COMPONENT_CROSS_ACCOUNT";
    RuleComponent["RULE_COMPONENT_CROSS_REGION"] = "RULE_COMPONENT_CROSS_REGION";
    RuleComponent["RULE_COMPONENT_CROSS_CLOUD_PROVIDER"] = "RULE_COMPONENT_CROSS_CLOUD_PROVIDER";
    RuleComponent["RULE_COMPONENT_ZERO_ERRORS"] = "RULE_COMPONENT_ZERO_ERRORS";
})(RuleComponent || (RuleComponent = {}));
